import { FiChevronRight } from "react-icons/fi";
import DreamHomeImg from "../../../assets-user/DreamHome.png";
import BuyersGuiderImg from "../../../assets-user/BuyerGuid.png";
import HomeBuyersImg from "../../../assets-user/HomeBuyers.png";
import BuyersJournalImg from "../../../assets-user/BuyerJournal.png";

const TopArticles = () => {
  const articles = [
    {
      id: 1,
      title: "Keys to Your Dream Home",
      description:
        "Explore expert tips, market insights, and step-by-step guides to make your property buying journey smooth.",
      image: DreamHomeImg,
      timeAgo: "1 Month ago",
    },
    {
      id: 2,
      title: "The Property Buyer's Guide",
      description:
        "From budgeting to legal checks, discover everything you need to know before purchasing your next home.",
      image: BuyersGuiderImg,
      timeAgo: "1 Month ago",
    },
    {
      id: 3,
      title: "Smart Homebuyers Hub",
      description:
        "Simplifying the buying process with insights on property trends, financing, and expert guidance.",
      image: HomeBuyersImg,
      timeAgo: "1 Month ago",
    },
    {
      id: 4,
      title: "LeadBook Buyer's Journal",
      description:
        "Trusted stories, tips, and strategies for making confident and informed property buying decisions.",
      image: BuyersJournalImg,
      timeAgo: "1 Month ago",
    },
  ];

  return (
    <div className="bg-white px-4 sm:px-6 lg:px-10" data-aos="fade-up">
      <div className="mx-auto">
        {/* Header Section */}
        <div
          className="flex items-center justify-between mb-2 sm:mb-3 md:mb-4 lg:mb-6"
          data-aos="fade-down"
        >
          <h2
            className="font-medium text-[#031722] text-lg sm:text-xl md:text-2xl lg:text-3xl"
            data-aos="fade-right"
          >
            Top Articles on Buying
          </h2>
          <button
            className="flex items-center gap-1 text-red-600 font-medium text-sm sm:text-base hover:translate-x-1 transition-all duration-300"
            data-aos="fade-left"
          >
            View More
            <FiChevronRight className="w-4 h-4 sm:w-5 sm:h-5" />
          </button>
        </div>

        {/* Article Cards */}
        <div
          className="flex overflow-x-auto lg:overflow-hidden gap-4 md:gap-6 lg:grid lg:grid-cols-4 scroll-smooth snap-x snap-mandatory"
          data-aos="zoom-in"
        >
          {articles.map((article, index) => (
            <div
              key={article.id}
              className="bg-white rounded-lg overflow-hidden shadow-sm border border-gray-200 flex-shrink-0 w-[80%] md:w-[70%] lg:w-auto snap-start hover:shadow-lg transition-all duration-300 group flex flex-col justify-between"
              data-aos="fade-up"
              data-aos-delay={index * 100}
            >
              {/* Image Section */}
              <div
                className="relative overflow-hidden h-48 sm:h-52 lg:h-56"
                data-aos="zoom-in"
              >
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-500"
                />
              </div>

              {/* Content Section */}
              <div className="px-4 pt-4 sm:px-5 sm:pt-5 flex flex-col">
                {/* Title */}
                <h3
                  className="font-medium text-[#031722] text-base sm:text-lg md:text-xl lg:text-[18.7px] mb-2 truncate"
                  title={article.title}
                >
                  {article.title}
                </h3>

                {/* Description */}
                <p
                  className="font-normal text-[#6A6A6A] text-sm sm:text-base md:text-[14.54px] mb-2"
                  style={{
                    display: "-webkit-box",
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                    WebkitLineClamp: 5,
                  }}
                >
                  {article.description}
                </p>

                {/* Footer (timeAgo) */}
                <p className="mt-auto flex justify-end mb-2 font-normal text-[#797979] text-xs sm:text-sm md:text-[12.46px]">
                  {article.timeAgo}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TopArticles;
